<template>
  <modal ref="modal" size="modal-lg" :modal-scrollable="modalScrollable">
    <template #header>
      <div class="text-gray-777 font-roboto uppercase">
        <span v-if="item.id">Editar </span>
        <span v-else>Adicionar </span>
        <span>{{ title }}</span>
      </div>
    </template>
    <template #body>
      <form @submit.prevent="submit">
        <div class="flex flex-wrap mb-4 px-4">
          <slot name="form" :item="item" />
        </div>
      </form>
    </template>
    <template #footer>
      <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="close">Cancelar</button>
      <loading-button :loading="processing" class="btn-blue px-6 py-2.5 text-xs leading-tight uppercase ml-1" type="submit" @click.prevent="submit">Salvar</loading-button>
    </template>
  </modal>
</template>
<script>
import { useForm } from '@inertiajs/inertia-vue3'
import { ref } from 'vue'
import Modal from '@/Shared/Modal'
import TextInput from '@/Shared/TextInput'
import SwitchInput from '@/Shared/SwitchInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Modal,
    LoadingButton,
  },
  props: {
    title: String,
    url: String,
    multipart: {
      type: Boolean,
      default: false,
    },
    processing: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: {
        errors: {},
      },
    },
    modalScrollable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const item = ref(props.item)
    const processing = ref(props.processing)

    const modal = ref(null)
        
    const openModalEdit = (i) => {
      processing.value = false
      item.value = useForm(i)
      modal.value.showModal = true
    }

    const closeModalEdit = () => {
      modal.value.showModal = false
    }

    return {
      openModalEdit,
      closeModalEdit,
      modal,
      item,
      processing,
    }
  },
  methods: {
    submit() {
      this.processing = true
      this.item.errors = {}
      const onFinish = () => {
        if(!Object.keys(this.item.errors).length) {
          this.$emit('submitForm', this.item)
          this.close()
        } else {
          this.$emit('submitError', this.item)
          this.processing = false
        }
      }

      if(this.item.id) {
        if(this.multipart) {
          this.item.post(`/${this.url}/${this.item.id}`, {
            forceFormData: true,
            onFinish: () => onFinish(),
          })
        } else {
          this.item.put(`/${this.url}/${this.item.id}`, {
            onFinish: () => onFinish(),
          })
        }
      } else {
        this.item.post(`/${this.url}`, {
          forceFormData: this.multipart,
          onFinish: () => onFinish(),
        })
      }
    },
    open() {
      this.$refs.modal.showModal = true
    },
    close() {
      this.$emit( 'closed' )
      this.$refs.modal.showModal = false
    },
  },
}
</script>
<style>
    
</style>